import { render, staticRenderFns } from "./Byod.vue?vue&type=template&id=361b6a5e"
import script from "./Byod.vue?vue&type=script&lang=js"
export * from "./Byod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports